<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="create-card-dialog"
      :open.sync="openDialog"
      :form-ref.sync="cardFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer une carte</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-alert type="warning">
          Ce formulaire est uniquement utilisé pour créer une carte
          personnalisée pour un utilisateur spécifique. Dans les autres cas
          utilisez l'édition de cartes.
        </v-alert>
        <v-text-field
          v-model="cardForm.id"
          label="Identifiant"
          hint="L'identifiant est utilisé par la carte, il doit être unique"
          persistent-hint
          :rules="rules.idRules"
        ></v-text-field>
        <v-text-field
          v-model="cardForm.password"
          label="Mot de passe"
          hint="Mot de passe associé à la carte pour la connexion au portail client"
          persistent-hint
          :rules="rules.passwordRules"
        ></v-text-field>
        <v-select
          v-model="cardForm.restrictionType"
          label="Type de restriction"
          :items="restrictionTypesChoice"
          hint="Peut être utilisé dans un autre contexte que le client"
          persistent-hint
          :rules="rules.restrictionType"
        ></v-select>
        <v-select
          v-model="cardForm.mode"
          label="Mode"
          :items="modesChoice"
          item-value="value"
          item-text="text"
          hint="Le mode détermine le profile de connexion"
          persistent-hint
          :rules="rules.modeRules"
        ></v-select>
        <v-select
          v-model="cardForm.cardModel"
          label="Modèle de carte"
          :items="cardModels"
          item-text="description"
          item-value="id"
          hint="Le modèle est utilisé pour déterminer la durée de connexion"
          persistent-hint
          :rules="rules.cardModelRules"
        ></v-select>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { toRefs, computed, onMounted } from "@vue/composition-api";
import { useCard } from "@/composables/card";
import { useCardModel } from "@/composables/card-model";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    clientPortal: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { cardData, createCard } = useCard();
    const { cardModels, listCardModels } = useCardModel();

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    onMounted(() => {
      listCardModels(props.clientPortal.partner.id);
    });

    /* Méthodes */
    const saveItem = async function () {
      await createCard(props.clientPortal.id);
      openDialog.value = cardData.createCardDialog;
    };

    return {
      createCard,
      ...toRefs(cardData),
      cardModels,
      saveItem,
      openDialog,
    };
  },
};
</script>
